import React from 'react';
import classNames from 'classnames';
import {
  BaseIconButtonProps,
  iconButtonIconSizeStyle,
  iconButtonSizeStyle,
  stateStyles,
} from './buttonStates';

export type IconButtonProps = Omit<BaseIconButtonProps, 'children'> & {
  type?: 'button' | 'submit';
  invertIcon?: boolean;
};

export const IconButton: React.FunctionComponent<IconButtonProps> = ({
  color,
  darkMode,
  size,
  icon: Icon,
  disabled,
  onClick,
  onMouseEnter,
  onMouseLeave,
  'data-testid': data_test_id,
  'aria-describedby': aria_describedby,
  type,
  invertIcon,
  ...props
}) => {
  return (
    <button
      disabled={disabled}
      className={classNames(
        'rounded-full flex flex-none items-center justify-center border-none',
        iconButtonSizeStyle(size),
        Object.values(stateStyles[color][darkMode ? 'darkMode' : 'lightMode'])
      )}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={data_test_id}
      aria-describedby={aria_describedby}
      type={type === 'submit' ? 'submit' : 'button'}
      {...props}
    >
      <Icon className={classNames(iconButtonIconSizeStyle(size), { invert: invertIcon })} />
    </button>
  );
};
